import React from "react";
import Grid from "@mui/material/Grid";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import layout from "../../../actprep-ui/constants/layout";
import AccountabilitySheet from "../../../components/AccountabilitySheet";
import ProductivitySheet from "../../../components/ProductivitySheet";
import { useTabs } from "../../../actprep-ui/hooks/ui";
import { Box, Stack } from "@mui/system";
import { Tab, Tabs } from "@mui/material";

export default function Accountability() {
  const { currentTab, setCurrentTab } = useTabs([
    "accountability-sheet",
    "productivity-sheet",
  ]);
  return (
    <Grid
      sx={{
        marginTop: `${layout.navBarHeight + 1}rem`,
      }}
      size={12}
    >
      <ContentBox
        sx={{
          maxHeight: "90vh",
          height: "500rem",
        }}
      >
        <Stack sx={{ height: "100%" }}>
          <Tabs
            value={currentTab}
            onChange={(event, val) => setCurrentTab(val)}
            centered
            sx={{ boxSizing: "border-box" }}
          >
            <Tab
              label="Student Accountability"
              value={"accountability-sheet"}
            />
            <Tab label="User Productivity" value={"productivity-sheet"} />
          </Tabs>
          <Box sx={{ flexGrow: 1, height: "95%" }}>
            {currentTab == "accountability-sheet" && <AccountabilitySheet />}
            {currentTab == "productivity-sheet" && <ProductivitySheet />}
          </Box>
        </Stack>
      </ContentBox>
    </Grid>
  );
}
